export const mariLines = {
  manga: {
    lines: [
      { speaker: "Mari", text: "Scroll, scroll, swipe and sigh—\nsome likes hit, some just fly by.\nStill no reason why." },
      { speaker: "Randy", text: "I swipe for deep chats—\nand sometimes free hotel soap.\nStill no reason, too." },

      { speaker: "Mari", text: "Mochi in my hand,\nthis café’s wi-fi is sweet—\nIRL feels banned." },
      { speaker: "Randy", text: "Wi-fi hugs my soul.\nBut I hug my mochi more—\nsquishy love is real." },

      { speaker: "Mari", text: "Flirting in DMs,\nbut you blink and they’re gone—poof!\nLove’s just HTML." },
      { speaker: "Randy", text: "HTML once broke\nmy homepage and my heart, girl.\nBut my pics still load." },

      { speaker: "Mari", text: "Pages turn so fast,\nbut the hero’s still alone—\nI feel seen at last." },
      { speaker: "Randy", text: "I’m that manga boy—\nbut with more chest hair and shoes.\nWanna share one arc?" },

      { speaker: "Mari", text: "Blue light on my face,\nfilter hides the empty space—\nbut my feed looks ace." },
      { speaker: "Randy", text: "Filters hide my teeth,\nand this mole I named ‘Terry.’\nStill get one like. Yours?" }
    ],
    voices: [
      "mari_manga1",
      "mari_manga2",
      "mari_manga3",
      "mari_manga4",
      "mari_manga5"
    ],
    randyVoices: [
      "randy_mari1",
      "randy_mari2",
      "randy_mari3",
      "randy_mari4",
      "randy_mari5"
    ]
  }
};

export default mariLines;
